import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { Billing } from '@models';
import { BillingService } from '@services';

export const billingResolver: ResolveFn<Nullable<Billing>> = () =>
  inject(BillingService).getBillingResolver();
